"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
require("./StepIndicator.css");
const StepIndicator = ({ currentStep, completedSteps }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const steps = [
        {
            key: 'validate',
            titleKey: 'steps.validate',
            completed: completedSteps.includes('validate'),
            active: currentStep === 'validate',
        },
        {
            key: 'phone',
            titleKey: 'steps.phone',
            completed: completedSteps.includes('phone'),
            active: currentStep === 'phone',
        },
        {
            key: 'otp',
            titleKey: 'steps.otp',
            completed: completedSteps.includes('otp'),
            active: currentStep === 'otp',
        },
        {
            key: 'card',
            titleKey: 'steps.card',
            completed: completedSteps.includes('card'),
            active: currentStep === 'card',
        },
    ];
    return ((0, jsx_runtime_1.jsx)("div", { className: "step-indicator", children: steps.map((step, index) => ((0, jsx_runtime_1.jsxs)("div", { className: `step ${step.active ? 'active' : ''} ${step.completed ? 'completed' : ''}`, children: [(0, jsx_runtime_1.jsx)("div", { className: "step-number", children: step.completed ? ((0, jsx_runtime_1.jsx)("span", { className: "checkmark", children: "\u2713" })) : ((0, jsx_runtime_1.jsx)("span", { children: index + 1 })) }), (0, jsx_runtime_1.jsx)("div", { className: "step-label", children: t(step.titleKey) }), index < steps.length - 1 && (0, jsx_runtime_1.jsx)("div", { className: "step-connector" })] }, step.key))) }));
};
exports.default = StepIndicator;
